import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectViewDefaults, updateDefaults } from '../../../../redux/panelDetailSlice';

export default function ViewModeSection() {
  const dispatch = useDispatch();
  const views = useSelector(selectViewDefaults);

  const handleChange = (field, checked) => {
    dispatch(updateDefaults({
      section: 'views',
      changes: { [field]: checked },
    }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-checkbox-col">
        <label>
          <input
            type="checkbox"
            checked={views.withDoors}
            onChange={e => handleChange('withDoors', e.target.checked)}
          />
          Kapakli gorunum olustur
        </label>
        <label>
          <input
            type="checkbox"
            checked={views.withoutDoors}
            onChange={e => handleChange('withoutDoors', e.target.checked)}
          />
          Kapaksiz gorunum olustur
        </label>
      </div>
    </div>
  );
}
